var map = {
	"./0x38/CROWD_SALE.json": 96073,
	"./0x38/ERC20_TOKEN.json": 36433,
	"./0x61/CROWD_SALE.json": 9839,
	"./0x61/ERC20_TOKEN.json": 64030
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33042;